import { useState } from "react";
import { useForgotPasswordAction } from "@rhino-project/core/queries";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Link } from "react-router-dom";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const { mutate: forgotPassword, isPending, error } = useForgotPasswordAction();

  return (
    <section className="mx-auto max-w-lg space-y-6">
      <Card className="border-primary/20">
        <CardHeader>
          <CardTitle>Reset Password</CardTitle>
          <CardDescription>Enter your email and we will send password reset instructions.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="reset-email">Email</Label>
            <Input id="reset-email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
          </div>
          <Button
            className="w-full"
            disabled={!email || isPending}
            onClick={() => forgotPassword({ email }, { onSuccess: () => setSent(true) })}
          >
            {isPending ? "Sending..." : "Send reset instructions"}
          </Button>
          {sent && <p className="text-sm text-primary">Reset instructions have been sent if this email exists.</p>}
          {error && <p className="text-sm text-destructive">Unable to send reset instructions. Please try again.</p>}
          <p className="text-sm text-muted-foreground"><Link to="/login">Return to sign in</Link></p>
        </CardContent>
      </Card>
    </section>
  );
}
